import { render, staticRenderFns } from "./RevStatus.vue?vue&type=template&id=381ea48e"
import script from "./RevStatus.vue?vue&type=script&lang=js"
export * from "./RevStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports